/* global window, HTMLElement */

/**
 * This component is used to show/hide the anchor navigation when the user
 * scrolls down at least 125px.
 */

export default class NavigationVisibilityHandler extends HTMLElement {
    private readonly scrollThreshold: number = 125;
    private ticking: boolean = false;

    connectedCallback() {
        this.#registerScrollListener();
    }

    disconnectedCallback() {
        // Clean up the scroll listener when component is removed
        window.removeEventListener('scroll', this.#handleScroll);
    }

    #handleScroll = () => {
        if (!this.ticking) {
            window.requestAnimationFrame(this.#checkScroll);
            this.ticking = true;
        }
    };

    #checkScroll = () => {
        if (window.scrollY > this.scrollThreshold) {
            this.classList.add('is-visible');
        } else {
            this.classList.remove('is-visible');
        }
        this.ticking = false;
    };

    #registerScrollListener() {
        window.addEventListener('scroll', this.#handleScroll, { passive: true });
    }

    public static defineElement(): void {
        if (!window.customElements.get('navigation-visibility-handler')) {
            window.customElements.define('navigation-visibility-handler', NavigationVisibilityHandler);
        }
    }
}
